import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Eyebrow from './Eyebrow';

/**
 * Encabezado de sección: eyebrow + h2 + lede opcional.
 * align='left'  → dos columnas (título | lede) en desktop
 * align='center'→ una columna centrada
 */
export default function SectionHeader({
  eyebrow,
  title,
  lede,
  dark = false,
  align = 'left',
  sx = {},
}) {
  const center = align === 'center';

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: center ? '1fr' : { xs: '1fr', md: '0.9fr 1.1fr' },
        gap: { xs: 3, md: 'clamp(30px, 6vw, 80px)' },
        alignItems: center ? 'center' : 'end',
        textAlign: center ? 'center' : 'left',
        maxWidth: center ? 680 : 'none',
        mx: center ? 'auto' : 0,
        mb: { xs: 6, md: 'clamp(48px, 6vw, 76px)' },
        ...sx,
      }}
    >
      <Box sx={center ? {} : { justifySelf: 'start' }}>
        {eyebrow && (
          <Box
            sx={{
              mb: '22px',
              display: 'flex',
              justifyContent: center ? 'center' : 'flex-start',
            }}
          >
            <Eyebrow tone={dark ? 'dark' : 'light'} center={center}>
              {eyebrow}
            </Eyebrow>
          </Box>
        )}
        {title && (
          <Typography
            variant="h2"
            component="h2"
            sx={{ color: dark ? 'text.heading' : 'text.primary' }}
          >
            {title}
          </Typography>
        )}
      </Box>
      {lede && (
        <Typography
          sx={{
            fontSize: 'clamp(15px, 1.4vw, 18px)',
            lineHeight: 1.8,
            color: dark ? 'text.onDark' : 'grey.600',
            alignSelf: center ? 'center' : 'end',
          }}
        >
          {lede}
        </Typography>
      )}
    </Box>
  );
}
